import { RPE_INFORMATION_SCREEN_TAB_IDS } from 'src/app/shared/rpe/rpe-information-screen.constants';
import { ActionIcons } from 'src/app/shared/utility/constants';
import {
  RPE_INVALID_TAB_AND_LEGEND_ID,
  rpeTabFormScope,
} from 'src/app/shared/rpe/rpe-module.helper';

export const BAG_RPE_MODULE_NAMES = ['Bag'] as const;
export const BAG_RPE_MODULE = BAG_RPE_MODULE_NAMES[0];

/**
 * Summary Gateway & Bag & Manifest by Incoming Container slide-toggle —
 * API `actionName` on Bag.
 */
export const BAG_RPE_ACTION_GATEWAY_BY_INCOMING_CONTAINER =
  'gateway, bag and manifest by incoming container';

export const BAG_RPE_INVALID_TAB_AND_LEGEND_ID = RPE_INVALID_TAB_AND_LEGEND_ID;

export const BAG_RPE_MISCELLANEOUS_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.miscellaneous;
export const BAG_RPE_STATUSCODES_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.statuscodes;
export const BAG_RPE_NOTES_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.notes;
export const BAG_RPE_ATTACHMENTS_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.attachments;

export const BAG_RPE_PAGE_FORM_SCOPE = rpeTabFormScope(BAG_RPE_INVALID_TAB_AND_LEGEND_ID);
export const BAG_RPE_MISCELLANEOUS_FORM_SCOPE = rpeTabFormScope(BAG_RPE_MISCELLANEOUS_TAB_ID);
export const BAG_RPE_STATUSCODES_FORM_SCOPE = rpeTabFormScope(BAG_RPE_STATUSCODES_TAB_ID);
export const BAG_RPE_NOTES_FORM_SCOPE = rpeTabFormScope(BAG_RPE_NOTES_TAB_ID);
export const BAG_RPE_ATTACHMENTS_FORM_SCOPE = rpeTabFormScope(BAG_RPE_ATTACHMENTS_TAB_ID);

/** Nested shipment-link actions on Bag Information (not module CRUD add/delete). */
export const BAG_RPE_LINK_SHIPMENT_ACTION = 'link shipment';
export const BAG_RPE_DELINK_SHIPMENT_ACTION = 'delink shipment';

/**
 * Bag summary reuses Shipment icon identityNames with Bag-specific API action names:
 * - `bulkBag` → bulk manifest
 * - `bulkGateway` → Scan Shipments
 */
export const BAG_RPE_ICON_ACTION_OVERRIDES: Record<string, string> = {
  [ActionIcons.bulkBag]: 'bulk manifest',
  [ActionIcons.bulkGateway]: 'scan shipments',
};

/** Bag Information shipment table: Add/Delete icons map to nested link actions. */
export const BAG_RPE_SHIPMENT_TABLE_ICON_ACTION_OVERRIDES: Record<string, string> =
  {
    [ActionIcons.add]: BAG_RPE_LINK_SHIPMENT_ACTION,
    [ActionIcons.delete]: BAG_RPE_DELINK_SHIPMENT_ACTION,
  };
